import { createSlice, PayloadAction } from '@reduxjs/toolkit'
import { ProviderCategory, SelectedPurse } from './providerPaySlice'

export type IReimbursementDetail = {
  store_name: string
  amount: number
}



export type IReimbursementPurse = {
  id: number
  title: string
  amount: number
}

interface ReimbursementState {
  details: IReimbursementDetail
  purses: SelectedPurse[]
  documents: string[]
  submitted?: boolean
  categories: ProviderCategory[]
  comment: string
  po_number: string
}

const initialState: ReimbursementState = {
  details: {
    amount: 0,
    store_name: '',
  },
  purses: [],
  documents: [],
  categories: [],
  submitted: false,
  comment: "",
  po_number: "",
}

const reimubrusementSlice = createSlice({
  name: 'reimubrusementApplication',
  initialState,
  reducers: {
    setReimbursementDetails: (
      state,
      action: PayloadAction<IReimbursementDetail>
    ) => {
      state.details = action.payload
    },
    setReimbursementPurses: (state, action: PayloadAction<SelectedPurse[]>) => {
      state.purses = action.payload
    },
    setReimbursementDocuments: (state, action: PayloadAction<string[]>) => {
      state.documents = action.payload
    },
    setReimbursementSubmitted: (state, action: PayloadAction<boolean>) => {
      state.submitted = action.payload
    },
    setReimbursementState: (
      state,
      action: PayloadAction<Partial<ReimbursementState>>
    ) => {
      return (state = { ...state, ...action.payload })
    },
    resetReimbursementData: () => initialState,
  },
})

export const {
  setReimbursementDetails,
  setReimbursementPurses,
  setReimbursementDocuments,
  setReimbursementState,
  setReimbursementSubmitted,
  resetReimbursementData,
} = reimubrusementSlice.actions

export default reimubrusementSlice.reducer
